/**
 * @typedef {Object} Destination
 * @property {number} id
 * @property {string} titleEn
 * @property {string} titleFr
 * @property {string} greeting
 * @property {string} descriptionFr
 * @property {string} descriptionEn
 * @property {string} imgUrl
 * @property {string} article
 */

import ApiService from "../ApiService"

class DestinationService extends ApiService {
  /**
   *
   * @param {Object} parameters The query parameters.
   */
  constructor(parameters = {}) {
    super(`${process.env.VUE_APP_CONTEST_API}api/v1/destinations`, parameters)
  }

  /**
   *
   * @return {Promise<{data: Destination[]}>}
   */
  getDestinations() {
    return this.removeParameters()
      .submit("get")
      .then(res => {
        return res.data
      })
  }
}

export default DestinationService
